import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './utills/axiosInstance';

export default function CallBack() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('session_state');

    if (!code) {
      console.error("No code in URL");
      navigate("/", { replace: true });
      return;
    }

    if (code && state && !localStorage.getItem('oauth_in_progress')) {
      setLoading(true);
      localStorage.setItem('oauth_in_progress', 'true');
      axiosInstance.post('/auth/token', { code, state })
        .then((res) => {
          setProfile(res.data.profile);
          localStorage.setItem('token', res.data.access_token);
          localStorage.removeItem('oauth_in_progress');
          window.history.replaceState({}, document.title, window.location.pathname);
          localStorage.setItem('profile', JSON.stringify(res.data.profile));
          localStorage.setItem('data', JSON.stringify(res.data.data));
          const token = localStorage.getItem('token');
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          setLoading(false);
          navigate("/dashboard", { replace: true });
        })
        .catch((err) => {
          setLoading(false);
          localStorage.removeItem('oauth_in_progress');
          console.error('❌ Login failed:', err.response?.data || err.message);
          window.history.replaceState({}, document.title, window.location.pathname);
          if (err.response?.status === 400 && err.response.data?.details?.error === 'invalid_grant') {
            // Code already redeemed: likely previous successful login, check for existing session on home
            navigate("/", { replace: true });
          } else if (err.response?.status === 403) {
            navigate("/", { replace: true, state: { error: err.response.data.error } });
          } else {
            navigate("/", { replace: true });
          }
        });
    } else {
      console.error('No code parameter found in URL or OAuth in progress.');
      window.history.replaceState({}, document.title, window.location.pathname);
      // navigate("/", { replace: true });
    }
  }, [backendUrl, navigate]);

  if(loading){
    return <div>Loading...</div>
  }

  return <></>;
}
